import {
    makeStyles,
    createStyles,
    Theme,
} from '@bb-ui/react-library/dist/components/styles';

export const useStyles = makeStyles(
    (theme: Theme) =>
        createStyles({
            textButton: {
                minHeight: 24,
            },
            buttonText: {
                marginInlineEnd: theme.spacing(1),
            },
            // WCAG 2.2 SC 2.5.8 minimum target size.
            iconButton: {
                width: 24,
                height: 24,
                minWidth: 24,
                minHeight: 24,
                padding: 0,
            },
            copiedIcon: {
                color: theme.palette.success.main,
            },
            status: {
                fontSize: '0.875rem',
            },
            screenReaderOnly: {
                clipPath: 'inset(100%)',
                clip: 'rect(1px 1px 1px 1px)',
                height: '1px',
                overflow: 'hidden',
                position: 'absolute',
                whiteSpace: 'nowrap',
                width: '1px',
            },
        }),
    {
        name: 'CopyButton-',
    },
);
